import React, { FC } from 'react';
// images
import SMBLogo from '../../assets/logos/Logo-Compact.png';
import RabrenLogo from '../../assets/logos/Logo-Compact-Rabren.png';

const { isRabren } = require('../../buildSettings.json');

interface ICompactLogoProps {
  className?: string;
}

export const CompactLogoWidth = isRabren === 'true' ? 30 : 54;
export const CompactLogoHeight = 30;

export const CompactLogo: FC<ICompactLogoProps> = ({ className }) => {
  return <img src={isRabren === 'true' ? RabrenLogo : SMBLogo} alt="logo" className={className} />;
};
